export var UPDATE_SUBSCRIPTION_GROUPS = 'UPDATE_SUBSCRIPTION_GROUPS';
export var SET_SUBSCRIPTION_GROUP = 'SET_SUBSCRIPTION_GROUP';

export var UPDATE_SUBSCRIBER_ASSETS = 'UPDATE_SUBSCRIBER_ASSETS';
export var UPDATE_SUBSCRIBER_SUBSCRIPTIONS = 'UPDATE_SUBSCRIBER_SUBSCRIPTIONS';
export var UPDATE_SUBSCRIBER_SUBSCRIPTION = 'UPDATE_SUBSCRIBER_SUBSCRIPTION';

export var SET_IDENTITIES = 'SET_IDENTITIES';

export var SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';

export var SET_ERRORS = 'SET_ERRORS';

export var SET_PAYMENT_GATEWAYS = 'SET_PAYMENT_GATEWAYS';

export var SET_SUBSCRIPTION_ATTEMPTS = 'SET_SUBSCRIPTION_ATTEMPTS';

export var SET_SUBSCRIPTION_PLAN = 'SET_SUBSCRIPTION_PLAN';

export var SET_COUPONS = 'SET_COUPONS';

export var UPDATE_SUBSCRIPTIONS_REPORTS = 'UPDATE_SUBSCRIPTIONS_REPORTS';

export var SET_SETTINGS = 'SET_SETTINGS';

export var SET_ACCOUNT_USERS = 'SET_ACCOUNT_USERS';

export var SET_WEBHOOKS = 'SET_WEBHOOKS';
